import { Component, computed, input, output } from '@angular/core';

/**
 * Rodapé de paginação estilo Dashkit (Anterior · números · Próximo).
 * O host é o próprio `.card-footer`; esconde-se quando há uma só página.
 * Paginação é client-side: o pai fatia a lista pela página atual.
 */
@Component({
  selector: 'app-pagination',
  host: {
    class: 'card-footer d-flex justify-content-between',
    '[class.d-none]': 'pageCount() <= 1',
  },
  template: `
    <ul class="pagination pagination-tabs card-pagination">
      <li class="page-item" [class.disabled]="page() <= 1">
        <a class="page-link ps-0 pe-4 border-end" (click)="go(page() - 1)">
          <i class="fe fe-arrow-left me-1"></i><span class="pg-label">Anterior</span>
        </a>
      </li>
    </ul>

    <ul class="pagination pagination-tabs card-pagination">
      @for (p of pages(); track p) {
        <li [class.active]="p === page()"><a class="page" (click)="go(p)">{{ p }}</a></li>
      }
    </ul>

    <ul class="pagination pagination-tabs card-pagination">
      <li class="page-item" [class.disabled]="page() >= pageCount()">
        <a class="page-link ps-4 pe-0 border-start" (click)="go(page() + 1)">
          <span class="pg-label">Próximo</span><i class="fe fe-arrow-right ms-1"></i>
        </a>
      </li>
    </ul>
  `,
  // No telemóvel o rodapé não cabia: o "Próximo" ficava cortado fora do cartão e não se chegava à
  // página seguinte. Ficam as setas e os números.
  styles: `
    @media (max-width: 575.98px) {
      :host { padding-left: 0.5rem; padding-right: 0.5rem; }
      .pg-label { display: none; }
      .page-link { padding: 0.5rem 0.75rem !important; border: 0 !important; }
      .page-link i { margin: 0 !important; }
      .page { padding: 0.5rem 0.4rem; }
    }
  `,
})
export class Pagination {
  readonly total = input.required<number>();
  readonly pageSize = input(10);
  readonly page = input.required<number>();
  readonly pageChange = output<number>();

  readonly pageCount = computed(() => Math.max(1, Math.ceil(this.total() / this.pageSize())));

  /** Janela de até 7 páginas ao redor da atual. */
  readonly pages = computed(() => {
    const count = this.pageCount();
    const current = this.page();
    if (count <= 7) {
      return Array.from({ length: count }, (_, i) => i + 1);
    }
    const end = Math.min(count, Math.max(1, current - 2) + 4);
    const start = Math.max(1, end - 4);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  });

  protected go(p: number): void {
    if (p >= 1 && p <= this.pageCount() && p !== this.page()) {
      this.pageChange.emit(p);
    }
  }
}
